module.exports = __webpack_public_path__ + "static/media/888.dbe3e7fc.png";